import React from 'react';
import styles from './Teen62.module.css';

// Reuse the existing card back import logic or pass it down? 
// For now, assuming assets are in /assets/img/cards/
const cardPattiBack = "/assets/img/cards/patti_back.png"; // Default back

const Teen62Visual = ({ data }) => {
    // Data format: "5HH,ASS,..."
    // We expect the parent to pass the full string or pre-parsed data
    // Let's assume raw string from API: "5HH,ASS,8CC,9DD,10CC,1"
    
    const cardString = data || "";
    const cardTokens = cardString.split(",").map(t => t.trim());
    
    const getCardImage = (token) => {
        if (!token || token === "1" || token === "0") return cardPattiBack; 
        return `/assets/img/cards/${token}.png`;
    };

    // TeenPatti 62 Logic:
    // Player A: Indices 0, 2, 4
    // Player B: Indices 1, 3, 5
    
    const playerACards = [0, 2, 4].map(i => {
        const token = cardTokens[i];
        return getCardImage(token);
    });

    const playerBCards = [1, 3, 5].map(i => {
        const token = cardTokens[i];
        return getCardImage(token);
    });

    return (
        <div className={styles.teen62Container}>
            <div className={styles.playerSection}>
                <span className={styles.playerName}>Player A</span>
                <div className={styles.playerCards}>
                    {playerACards.map((card, index) => (
                         <img 
                         key={`${index}-${card}`} 
                         src={card} 
                         alt={`Player A card ${index + 1}`}
                         className={styles.cardImage}
                         onError={(e) => {
                           e.target.style.display = 'none';
                         }}
                       />
                    ))}
                </div>
            </div>
             <div className={styles.playerSection}>
                <span className={styles.playerName}>Player B</span>
                <div className={styles.playerCards}>
                    {playerBCards.map((card, index) => (
                         <img 
                         key={`${index}-${card}`} 
                         src={card} 
                         alt={`Player B card ${index + 1}`}
                         className={styles.cardImage}
                         onError={(e) => {
                           e.target.style.display = 'none';
                         }}
                       />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Teen62Visual;
